export default __webpack_public_path__ + "static/media/widget_play.09c09b2d.svg";